import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EncryptService } from './encrypt.service';

@Injectable({
  providedIn: 'root'
})
export class RefreshTokenService {



  constructor(
    private http: HttpClient,
    private encryptService: EncryptService
  ) { }


  getToken(): Observable<any> {
    const API_URL = `${environment.keycloakUrl}/realms/${environment.keycloakRealm}`;
    const clientId = environment.keycloakClientId;

    const url = `${API_URL}/protocol/openid-connect/token`;


    const refreshToken = sessionStorage.getItem('refreshLogIn');
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    const body = new URLSearchParams();
    body.set('grant_type', 'refresh_token');
    if (refreshToken != null) {
      body.set('refresh_token', refreshToken);
    }
    body.set('client_id', clientId);

    return this.http.post(url, body.toString(), { headers: headers });
  }

}

